import {Navigate, createBrowserRouter} from 'react-router-dom';

import Home from '@/pages/Home'
import OurProducts from '@/pages/OurProducts'
import ProductDetail from '@/pages/ProductDetail'
import ContactUs from '@/pages/ContactUs'
import SignupLogin from '@/pages/SignupLogin'
import ShoppingCart from '@/pages/ShoppingCart'
import AboutUs from '@/pages/AboutUs'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import TermsOfService from '@/pages/TermsOfService'
import MyProfile from '@/pages/MyProfile'
import EditOrder from '@/pages/EditOrder'
import EditOrderProducts from '@/pages/EditOrderProducts'
import EditOrderProductDetail from "@/pages/EditOrderProductDetail";
import Search from "@/pages/Search"
import BrandProducts from "@/pages/BrandProducts"
import {getToken} from '@/common';

const isLogged = !!getToken()

const router = createBrowserRouter([
  {
    path: '/home',
    element: <Home />, // element: isLogged ? <Home /> : <Navigate to="/signupLogin" />
  },
  {
    path: '/ourProducts',
    element: <OurProducts />,
  },
  {
    path: '/ourProducts/:group',
    element: <OurProducts />,
  },
  {
    path: '/ourProducts/:group/:category',
    element: <OurProducts />,
  },
  {
    path: '/ourProducts/category2/:category2',
    element: <OurProducts />,
  },
  {
    path: '/productDetail/:id',
    element: <ProductDetail />,
  },
  {
    path: '/signupLogin',
    element: <SignupLogin />,
  },
  {
    path: '/shoppingCart',
    element: isLogged ? <ShoppingCart /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/contactUs',
    element: <ContactUs />,
  },
  {
    path: '/aboutUs',
    element: <AboutUs />,
  },
  {
    path: '/privacyPolicy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/termsOfService',
    element: <TermsOfService />,
  },
  {
    path: '/myProfile',
    element: isLogged ? <MyProfile /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrder/:id',
    element: isLogged ? <EditOrder /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/editOrderProducts',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProducts/:group',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
    
  },
  {
    path: '/editOrderProducts/:group/:category',
    element: isLogged ? <EditOrderProducts /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/editOrderProductDetail/:id',
    element: isLogged ? <EditOrderProductDetail /> : <Navigate to="/signupLogin" />,
  },
  {
    path: '/search',
    element: <Search />,
  },
  {
    path: '/brandProducts/:category2',
    element: <BrandProducts />,
  },
  {
    path: '*',
    element: <Navigate to={'/home'} replace={true} />
  },
]);

export default router
